//全局组件
import commonTable from '../common/table'
import hiddenColumn from '../common/hiddenColumn'
import upload from '../common/upload'
import exportComment from "../common/export";
import log from "../common/log";
import imgUpload from "../common/imgUpload";
import Spread from "../common/Spread";
const CommonTable = {
    install: function (Vue) {
        Vue.component('commonTable', commonTable)
        Vue.component('hidden-column', hiddenColumn)
        Vue.component('upload', upload)
        Vue.component('exportComment', exportComment)
        Vue.component('logLook', log)
        Vue.component('imgUpload', imgUpload)
        Vue.component('Spread', Spread)

    }
}
export default CommonTable